Hop.defineModule('acquisition-search-form-tracking-rebranding2020', (domRoot, params) => {
    /* eslint-disable indent */
    const conf = [
        {
            target: domRoot.querySelector('.q_header_banner'),
            sendEventOn: 'focus',
            gtmEventDef: params.gtmEventOnJobFieldFocus
                ? params.gtmEventOnJobFieldFocus
                : {
                      category: 'lp-cover',
                      actio: 'fill',
                      label: 'expertise',
                  },
        },
        {
            target: domRoot.querySelector('.location_header_banner'),
            sendEventOn: 'focus',
            gtmEventDef: params.gtmEventOnLocationFieldFocus
                ? params.gtmEventOnLocationFieldFocus
                : {
                      category: 'lp-cover',
                      actio: 'fill',
                      label: 'location',
                  },
        },
        {
            target: domRoot,
            sendEventOn: 'submit',
            gtmEventDef: params.gtmEventOnSubmit
                ? params.gtmEventOnSubmit
                : {
                      category: 'lp-cover',
                      actio: 'launch-search',
                  },
        },
    ];
    /* eslint-enable indent */

    conf.forEach((c) => {
        c.target.addEventListener(c.sendEventOn, () => Hop.gtm.push(c.gtmEventDef));
    });
});
